import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home-agenda v2-agenda" }
const _hoisted_2 = { class: "agenda" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "agenda-type-box" }
const _hoisted_5 = { class: "before-selectbox" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "check",
  class: "top-label"
}, null, -1)
const _hoisted_7 = { class: "selectBox" }
const _hoisted_8 = { class: "mid-box" }
const _hoisted_9 = { class: "mid-box-check" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "mid-box-text bonus" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "mid-core row" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tri" }, null, -1)
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "progress-area quorum-area test-area" }
const _hoisted_19 = { class: "progress-area" }
const _hoisted_20 = { class: "top-box main" }
const _hoisted_21 = { class: "box1" }
const _hoisted_22 = { class: "id-name" }
const _hoisted_23 = { class: "box2" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "text" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-view-more-white" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ui_select = _resolveComponent("ui-select")!
  const _component_ui_grid_cell = _resolveComponent("ui-grid-cell")!
  const _component_ui_grid = _resolveComponent("ui-grid")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { initConnected: _ctx.setConnected }, null, 8, ["initConnected"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "styled-checkbox",
              type: "checkbox",
              id: "check",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.votedAgenda) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateChange && _ctx.stateChange(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.votedAgenda]
            ]),
            _hoisted_6,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("agenda.voted-agenda")), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("section", {
              class: _normalizeClass(["select bag", [_ctx.selectToggle === true ? 'on' : '']]),
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectToggleBtn && _ctx.selectToggleBtn(...args)))
            }, [
              _createVNode(_component_ui_select, {
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected) = $event)),
                onSelected: _cache[3] || (_cache[3] = ($event: any) => (_ctx.stateChange())),
                options: _ctx.options
              }, null, 8, ["modelValue", "options"])
            ], 2)
          ])
        ]),
        _createVNode(_component_ui_grid, {
          class: "demo-grid max-width agenda-box",
          position: "left"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agendaList, (data, i) => {
              return (_openBlock(), _createBlock(_component_ui_grid_cell, {
                class: "demo-cell",
                columns: "6",
                key: i
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", {
                          class: _normalizeClass({
                                            pendingc: data.state === 0,
                                            notquoromc: data.state === 1,
                                            proceedc: data.state === 2,
                                            approvedc: data.state === 3,
                                            completedc: data.state === 4,
                                            rejectionc: data.state === 5,
                                        })
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["icon", {
                                                pending: data.state === 0,
                                                notquorom: data.state === 1,
                                                proceed: data.state === 2,
                                                approved: data.state === 3,
                                                completed: data.state === 4,
                                                rejection: data.state === 5,
                                            }])
                          }, null, 2),
                          _createTextVNode(_toDisplayString(data.stateNm), 1)
                        ], 2),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.i18n.t("landing.posted")) + " " + _toDisplayString(data.posted) + " " + _toDisplayString(_ctx.i18n.t("landing.utc")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("p", null, _toDisplayString(data.title), 1),
                        _createElementVNode("p", {
                          class: "sub-text",
                          innerHTML: data.message.replaceAll('\r\n', '').replace('<br />', '').replace('<br />', '')
                        }, null, 8, _hoisted_12),
                        _createElementVNode("p", {
                          innerHTML: data.hashtag
                        }, null, 8, _hoisted_13)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", {
                          class: "more col-6 type2",
                          onClick: ($event: any) => (_ctx.agendaDetailPush(data))
                        }, [
                          _createElementVNode("a", null, [
                            _createTextVNode(_toDisplayString(_ctx.i18n.t("landing.view_detail")) + " ", 1),
                            _hoisted_16
                          ])
                        ], 8, _hoisted_15),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.quorumItem, (quorum) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "quorum-bar",
                                key: quorum
                              }, [
                                _createElementVNode("p", {
                                  class: "text",
                                  style: _normalizeStyle({ left: quorum.percent + '%' })
                                }, _toDisplayString(_ctx.i18n.t("landing.quorum")) + " " + _toDisplayString(data.quorum) + " %", 5),
                                _createElementVNode("p", {
                                  class: "arrow",
                                  style: _normalizeStyle({ left: quorum.percent2 + '%' })
                                }, null, 4)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.progressItem, (progress) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "progress-item",
                                key: progress,
                                style: _normalizeStyle({ 'background-color': progress.color, width: progress.percent + '%' })
                              }, _toDisplayString(progress.pro), 5))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("agenda.id")) + " " + _toDisplayString(data.idx), 1),
                        _createElementVNode("span", null, _toDisplayString(data.ctName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.i18n.t("landing.vote")) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(data.turnout) + " %", 1)
                        ]),
                        _createElementVNode("div", {
                          class: "block",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.snapShotBlockNumber(data.blockNumber))
                        }, [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.i18n.t("landing.start_block")), 1),
                          _createElementVNode("span", null, [
                            _createTextVNode("# " + _toDisplayString(data.blockNumber) + " ", 1),
                            _hoisted_26
                          ])
                        ], 8, _hoisted_24)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        (_ctx.currentPageNo < _ctx.pageCount)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "more-box btn-hover",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.moreWaitList && _ctx.moreWaitList(...args)))
            }, _toDisplayString(_ctx.$t("staking.more")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}